import React from "react";
import EditSubscriptionTable from "./EditSubscriptionTable";
import UpdateSubscription from "./UpdateSubscription";
import SubscriptionHistory from "./SubscriptionHistory";
import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EditSubscription = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="font-semibold antialiased tracking-normal text-[22px]">
          Edit Subscription
        </p>
        <button
          onClick={() => navigate(-1)}
          className="bg-black text-white h-10 w-[130px] rounded-[8px] flex justify-center items-center gap-2 hover:ring-2 hover:ring-gray-300 transition-all duration-300"
        >
          <ArrowLeftIcon />
          <p>Back</p>
        </button>
      </div>

      <div className="mt-10">
        <EditSubscriptionTable />
      </div>
      <div className="mt-10">
        <UpdateSubscription />
      </div>
      <div className="mt-10">
        <SubscriptionHistory />
      </div>
    </div>
  );
};

export default EditSubscription;
